<template>
	<div class='form-reestr-block'>
		<p-button :disabled='isForming' @click='formReestr' label='Выписка в реестры' class='p-button-sm form-reestr-block__btn'/>
		<p-spinner v-if='isForming'/>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const FORM_REESTR = ROOT_API + 'form_reestr/index.php';

	export default {
		name: 'LpoDataSidebarFormReestr',

		data: () => ({
			isForming: false,
		}),	

		computed: {
			...mapState('lpoData', {
				currentLpo: state => state.currentLpo,
			})
		},	

		methods: {
			formReestr() {

				const form = new FormData();
	  		form.append('lpo_id', this.currentLpo.lpo_id);
	  		form.append('lease_id', this.currentLpo.lease_id);

	  		this.isForming = true;
	  		fetch(FORM_REESTR, {
	  			credentials: 'include',
	  			method: 'post',
	  			body: form
	  		})
	  		.then(res => res.json())
	  		.then(res => {

					const a = document.createElement('a');

					a.setAttribute('href', res.file);
					a.setAttribute("download", res.name);

					document.body.appendChild(a);
					a.click();
					a.remove();

	  		})
	  		.catch(err => {
	  			this.$toast.add({severity: 'warn', detail: 'При формировании информации для реестров произошла ошибка', life: 10000});

	  			throw err;
	  		})
	  		.finally(() => { this.isForming = false; });
			},
		}
	};
</script>

<style scoped>
	.form-reestr-block {
		display: flex;
		gap: 0.5rem;
		align-items: center;
	}

	.form-reestr-block__btn {
		width: 100%;
	}

	.p-progress-spinner {
		height: 30px;
		width: 30px;
	}
</style>